import queryString from 'query-string'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { queryFromSearchParams } from 'helpers/util'

import styles from './tabNavbar.module.scss'

interface Props {
    navArr: string[]
    type: string
    active?: string
    onChange?: (value: string) => void
    useUrl?: boolean
}

const ButtonTabNavbar = ({
    navArr,
    type,
    active,
    onChange,
    useUrl = true
}: Props) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const values = queryString.parse(location.search)

    const currentActive = active ?? values.type

    return (
        <div
            className={`${styles.navbar} ${type === 'dark' ? styles.dark : ''}`}
        >
            {navArr.map((navLink: string, key: number) => {
                const isActive = currentActive === navLink

                return (
                    <button
                        className={`${styles.button} ${
                            isActive ? styles.active : styles.inactive
                        }`}
                        onClick={() => {
                            onChange?.(navLink)

                            if (!useUrl) return

                            const query = queryFromSearchParams(
                                values,
                                `?type=${navLink}`
                            )

                            navigate(query)
                        }}
                        key={key}
                    >
                        {t(navLink || 'Missing')}
                    </button>
                )
            })}
        </div>
    )
}

export default ButtonTabNavbar